import { executeCalculation } from "./_calculation.js";
import { syncInputValueRealtime } from "./_input.js";
import { getOtherTabInput } from "./_dom.js";
import debounce from "lodash.debounce";

/**
 * 入力フィールドの監視を設定
 * @param {string} type 物件種別
 * @param {Object} context コンテキストオブジェクト
 * @param {Object} context.inputs 入力要素オブジェクト
 * @param {HTMLElement} context.resultElement 結果表示要素
 */
export const setupInputListeners = (type, context) => {
    const inputFields =
        type === "house"
            ? [
                  { element: context.inputs.zipcode, name: "estate_zip" },
                  {
                      element: context.inputs.buildingArea,
                      name: "building_area",
                  },
                  { element: context.inputs.landArea, name: "land_area" },
                  { element: context.inputs.yearsOld, name: "years_old" },
              ]
            : [
                  { element: context.inputs.zipcode, name: "estate_zip" },
                  { element: context.inputs.landArea, name: "land_area" },
              ];

    // デバウンス処理（入力が止まってから800ms後に実行）
    const debouncedCalculation = debounce(() => {
        executeCalculation(type, context);
    }, 800);

    inputFields.forEach(({ element, name }) => {
        if (element) {
            // 入力時のイベントリスナー
            element.addEventListener("input", (e) => {
                const fieldName = e.target.name;
                const value = e.target.value;

                // 郵便番号と土地面積をリアルタイムで同期
                if (fieldName === "estate_zip" || fieldName === "land_area") {
                    const otherInput = getOtherTabInput(type, fieldName);
                    if (otherInput) {
                        syncInputValueRealtime(otherInput, value);
                    }
                }

                // 価格計算
                debouncedCalculation();
            });

            element.addEventListener("blur", () => {
                // フォーカスが外れた時は即座に実行
                executeCalculation(type, context);
            });
        }
    });
};
